import { FC } from 'react';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { Button } from '@components/Core/Button';
import { StatusType } from '@/types/common';
import { IBrandsMarker } from '@stores/brands/types';
import { MarkersPopupTransFields } from './types';
import { markersPopupTranslations } from './translations';
import { statusBadgeTranslations } from '@/components/Core/StatusBadge/translations';
import { observer } from 'mobx-react-lite';

export const MarkersPopup: FC<{ onSelect: (marker: IBrandsMarker) => void }> = observer(
  ({ onSelect }) => {
    const {
      popupStore: { closePopup },
      brandsStore: { markers },
    } = useStore();

    const { t } = useMyTranslations<MarkersPopupTransFields>([markersPopupTranslations.name]);

    const onClick = (marker: IBrandsMarker) => {
      onSelect(marker);
      closePopup();
    };

    return (
      <div className="flex flex-col justify-stretch items-center overflow-scroll max-h-[50vh]">
        <p className="default-text mb-[24px] w-full">{t('title')}</p>
        <div className="grid grid-cols-3 justify-center items-center gap-[16px] mobile-markers">
          {markers?.map((item) => (
            <button
              key={item.type}
              type="button"
              className="flex-centred h-[auto] p-[20px] bg-container-bg rounded-[12px]"
              onClick={() => onClick(item)}
            >
              <img src={item.pointerUrl} />
            </button>
          ))}
        </div>
      </div>
    );
  }
);
